import { Component, Input, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IModalData } from '../modal.interface';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-base-modal',
  imports: [CommonModule],
  templateUrl: './base-modal.component.html',
})
export class BaseModalComponent {
  @Input() modalData!: IModalData;
  @ViewChild('modalContent', { read: ViewContainerRef }) contentContainer!: ViewContainerRef;
  maximized: boolean = false;

  private componentToLoad!: Type<any>;
  outData: any = null;

  constructor(public activeModal: NgbActiveModal) {}

  setComponent(component: Type<any>) {
    this.componentToLoad = component;
    this.loadComponent();
  }

  ngAfterViewInit() {
    this.loadComponent();
  }

  private loadComponent() {
    if (this.contentContainer && this.componentToLoad) {
      this.contentContainer.clear();
      const componentRef = this.contentContainer.createComponent(this.componentToLoad);

      if (this.modalData?.data) {
        Object.assign(componentRef.instance, this.modalData.data);
      }
      // Para capturar datos desde el componente se crea un Output() con el nombre "outData" y se emite en cada cambio
      if ((componentRef.instance as any).outData) {
        (componentRef.instance as any).outData.subscribe((data: any) => {
          this.outData = data
        });
      }
      // Si se envia el cierre de modal desde el componente con Output() closeModal
      if ((componentRef.instance as any).closeModal) {
        (componentRef.instance as any).closeModal.subscribe(() => {
          this.activeModal.close();
        });
      }
  
    }
  }

  resize() {
    this.maximized = !this.maximized;
    this.activeModal.update({ fullscreen: this.maximized });
  }
}
